import type { DemoScript } from "../types";
import { TASKS_SCRIPT_COPY } from "./tasks-script.copy";

export const buildTasksScript = (): DemoScript => [
  {
    id: "tasks-intro",
    narrative: TASKS_SCRIPT_COPY.tasksIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "tasks-grid",
    narrative: TASKS_SCRIPT_COPY.tasksGrid.narrative,
    zoomTargetId: "tasks-grid",
    callout: {
      targetId: "tasks-grid",
      text: TASKS_SCRIPT_COPY.tasksGrid.callout,
    },
    durationMs: 5200,
  },
  {
    id: "tasks-modal-open",
    narrative: TASKS_SCRIPT_COPY.tasksModalOpen.narrative,
    zoomTargetId: "tasks-modal",
    callout: {
      targetId: "tasks-modal",
      text: TASKS_SCRIPT_COPY.tasksModalOpen.callout,
    },
    durationMs: 5400,
  },
  {
    id: "tasks-modal-title",
    narrative: TASKS_SCRIPT_COPY.tasksModalTitle.narrative,
    zoomTargetId: "tasks-modal-title",
    callout: {
      targetId: "tasks-modal-title",
      text: TASKS_SCRIPT_COPY.tasksModalTitle.callout,
    },
    durationMs: 5400,
  },
  {
    id: "tasks-modal-campaign",
    narrative: TASKS_SCRIPT_COPY.tasksModalCampaign.narrative,
    zoomTargetId: "tasks-modal-campaign",
    callout: {
      targetId: "tasks-modal-campaign",
      text: TASKS_SCRIPT_COPY.tasksModalCampaign.callout,
    },
    durationMs: 5200,
  },
  {
    id: "tasks-modal-platform",
    narrative: TASKS_SCRIPT_COPY.tasksModalPlatform.narrative,
    zoomTargetId: "tasks-modal-platform",
    callout: {
      targetId: "tasks-modal-platform",
      text: TASKS_SCRIPT_COPY.tasksModalPlatform.callout,
    },
    durationMs: 5400,
  },
  {
    id: "tasks-modal-format",
    narrative: TASKS_SCRIPT_COPY.tasksModalFormat.narrative,
    zoomTargetId: "tasks-modal-format",
    callout: {
      targetId: "tasks-modal-format",
      text: TASKS_SCRIPT_COPY.tasksModalFormat.callout,
    },
    durationMs: 5200,
  },
  {
    id: "tasks-modal-dates",
    narrative: TASKS_SCRIPT_COPY.tasksModalDates.narrative,
    zoomTargetId: "tasks-modal-dates",
    callout: {
      targetId: "tasks-modal-dates",
      text: TASKS_SCRIPT_COPY.tasksModalDates.callout,
    },
    durationMs: 5400,
  },
  {
    id: "tasks-roteiro-open",
    narrative: TASKS_SCRIPT_COPY.tasksRoteiroOpen.narrative,
    zoomTargetId: "roteiro-header",
    disableZoom: true,
    callout: {
      targetId: "roteiro-header",
      text: TASKS_SCRIPT_COPY.tasksRoteiroOpen.callout,
    },
    durationMs: 4800,
  },
  {
    id: "tasks-roteiro-toolbar",
    narrative: TASKS_SCRIPT_COPY.tasksRoteiroToolbar.narrative,
    zoomTargetId: "roteiro-toolbar",
    disableZoom: true,
    callout: {
      targetId: "roteiro-toolbar",
      text: TASKS_SCRIPT_COPY.tasksRoteiroToolbar.callout,
    },
    durationMs: 4800,
  },
  {
    id: "tasks-roteiro-sheet",
    narrative: TASKS_SCRIPT_COPY.tasksRoteiroSheet.narrative,
    zoomTargetId: "roteiro-sheet",
    disableZoom: true,
    callout: {
      targetId: "roteiro-sheet",
      text: TASKS_SCRIPT_COPY.tasksRoteiroSheet.callout,
    },
    durationMs: 5000,
  },
  {
    id: "tasks-roteiro-image",
    narrative: TASKS_SCRIPT_COPY.tasksRoteiroImage.narrative,
    zoomTargetId: "roteiro-image",
    callout: {
      targetId: "roteiro-image",
      text: TASKS_SCRIPT_COPY.tasksRoteiroImage.callout,
    },
    durationMs: 5400,
  },
  {
    id: "tasks-roteiro-end",
    narrative: TASKS_SCRIPT_COPY.tasksRoteiroEnd.narrative,
    zoomTargetId: "roteiro-fechamento",
    disableZoom: true,
    callout: {
      targetId: "roteiro-fechamento",
      text: TASKS_SCRIPT_COPY.tasksRoteiroEnd.callout,
    },
    durationMs: 5200,
  },
  {
    id: "tasks-outro",
    narrative: TASKS_SCRIPT_COPY.tasksOutro.narrative,
    durationMs: 3200,
  },
];
